import { answerInterface } from "../components/segments/QuestionSegment";

export interface LastAnswerData {
  round: number;
  lastTimeInMilliSeconds: number;
  answers: Array<answerInterface>;
}

export const UpdateTime = (time: number, Match_id: number) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + Match_id) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    stored_data.lastTimeInMilliSeconds = time - stored_data.round;
    updateStorage(stored_data, Match_id);
    return true;
  }
  return false;
};

export const UpdateQuestion = (round: number, Match_id: number) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + Match_id) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    if (round > stored_data.round) {
      stored_data.round = round;
      stored_data.lastTimeInMilliSeconds = 0;
    }
    updateStorage(stored_data, Match_id);
    return true;
  }
  return false;
};

export const UpdateAnswer = (
  answers: Array<answerInterface>,
  Match_id: number
) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + Match_id) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    if (stored_data.answers.length > 0) {
      for (var ans in answers) {
        if (stored_data.answers[ans].response_time_ms === 0) {
          stored_data.answers[ans] = answers[ans];
        }
      }
    } else {
      stored_data.answers = answers;
    }

    updateStorage(stored_data, Match_id);

    return true;
  }
  return false;
};

export const UpdateAnswerById = (
  answer: answerInterface,
  Match_id: number,
  index: number
) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + Match_id) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    stored_data.answers[index] = answer;
    updateStorage(stored_data, Match_id);

    return true;
  }
  return false;
};

export const updateStorage = (data: LastAnswerData, matchId: number) => {
  localStorage.setItem("resume_Data_" + matchId, JSON.stringify(data));
};
export const initStorageForMatch = (matchId: number) => {
  console.log("init_called", matchId);
  const initData: LastAnswerData = {
    round: 0,
    lastTimeInMilliSeconds: 0,
    answers: [],
  };
  return localStorage.setItem(
    "resume_Data_" + matchId,
    JSON.stringify(initData)
  );
};

export const getLastTime = (matchId: number, round: number) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + matchId) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    // if (round === stored_data.round)
    return stored_data.lastTimeInMilliSeconds;
    // else return 0;
  }
  return 0;
};
export const getQuestion = (matchId: number) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + matchId) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    return stored_data.round;
  }
  return 0;
};
export const getAnswer = (matchId: number): answerInterface[] => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + matchId) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    return stored_data.answers;
  }
  return [];
};

export const checkStorage = (matchId: number) => {
  let stored_data = JSON.parse(
    localStorage.getItem("resume_Data_" + matchId) + ""
  ) as LastAnswerData | undefined;
  if (stored_data && stored_data !== undefined) {
    return true;
  }
  return false;
};

export const deleteStorage = (matchId: number) => {
  localStorage.removeItem("resume_Data_" + matchId);
};
